import aucoin from '../assets/models/aucoin2.glb';
import archipel from '../assets/models/archipel.glb';
import cal from '../assets/models/cal2.glb';
import toolkit from '../assets/models/toolkit.glb';
import www from '../assets/models/www-pc2.glb';
import nan from '../assets/models/poly.glb';
import montage from '../assets/models/chairs.glb';
import posthuman from '../assets/models/flag.glb';
import twotowers from '../assets/models/lloss2.glb';
import transition from '../assets/models/portal.glb';
import woodblocks from '../assets/models/woodblocks2.glb';

export const models =  [
  { path: aucoin, position: { x: 0, y: -0.4, z: 0 }, scale: { x: 0.6, y: 0.6, z: 0.6 } },
  { path: archipel, position: { x: 0, y: -3.8, z: 0 }, scale: { x: 0.6, y: 0.6, z: 0.6 } },
  { path: cal, position: { x: 0, y: -7.2, z: 0 }, scale: { x: 0.5, y: 0.5, z: 0.5 } },
  { path: toolkit, position: { x: 0, y: -10.8, z: 0 }, scale: { x: 0.9, y: 0.9, z: 0.9 } },
  { path: www, position: { x: 0, y: -15.6, z: 0 }, scale: { x: 3.5, y: 3.5, z: 3.5 } },
  { path: nan, position: { x: 0, y: -17, z: 0 }, scale: { x: 0.4, y: 0.4, z: 0.4 } },
  { path: montage, position: { x: 0, y: -21.4, z: 0 }, scale: { x: 0.7, y: 0.7, z: 0.7 } },
  { path: posthuman, position: { x: 0, y: -24.3, z: 0 }, scale: { x: 3, y: 3, z: 3 } },
  { path: twotowers, position: { x: 0, y: -27.5, z: 0 }, scale: { x: 0.5, y: 0.5, z: 0.5 } },
  { path: transition, position: { x: 0, y: -30.9, z: 0 }, scale: { x: 0.25, y: 0.25, z: 0.25 } },
  { path: woodblocks, position: { x: 0, y: -34.7, z: 0 }, scale: { x: 0.4, y: 0.4, z: 0.4 } },
];
export default models